import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { RouteOutlet } from "./RouteOutlet";

const MAIN_CONTENT_ID = "main-content";

export function RootLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-parchment">
      <a
        href={`#${MAIN_CONTENT_ID}`}
        className="sr-only fixed left-4 top-4 z-50 rounded-md bg-barrel px-4 py-2 text-sm font-medium text-white shadow-md focus:not-sr-only focus:outline-none focus:ring-2 focus:ring-barrel focus:ring-offset-2 focus:ring-offset-parchment"
        onClick={(event) => {
          event.preventDefault();
          document.getElementById(MAIN_CONTENT_ID)?.focus();
        }}
      >
        Skip to main content
      </a>
      <Navbar />
      <main
        id={MAIN_CONTENT_ID}
        tabIndex={-1}
        className="flex-1 scroll-mt-24 focus:outline-none focus:ring-2 focus:ring-barrel focus:ring-offset-2 focus:ring-offset-parchment"
      >
        <RouteOutlet />
      </main>
      <Footer />
    </div>
  );
}
